import React from 'react'
import { TiBatteryHigh, TiLeaf, TiWarningOutline } from 'react-icons/ti'
import { IoIosSnow } from 'react-icons/io'
import { AiOutlineFire } from 'react-icons/ai'
import Moment from 'react-moment';

import './index.css'

const DeviceInfo = ({ data, deviceName }) => {

  let temperatureClass = 'none';
  
  function renderStatusIcon(temperatureClass) {
    switch (temperatureClass) {
      case 'normal':
        return (<TiLeaf />)
      case 'hot':
        return (<AiOutlineFire />)
      case 'cold':
        return (<IoIosSnow />)
      case 'none':
        return (<TiWarningOutline />)
      default:
        return (<TiWarningOutline />)
    }
  }

  // if (device.temperature < device.config.temperature.min)
  //   temperatureClass = 'cold'

  // if (device.temperature > device.config.temperature.max)
  //   temperatureClass = 'hot'

  return (
    <div className="Device-container">
       <div className={'device-travel ' + 'normal'}>
        <div className="device-header">
          <div className="device-title">
            {deviceName}
          </div>

          <div className="container-actions">
            <span>{data.battery}%</span>
            <TiBatteryHigh />
          </div>
        </div>

        <div className="device-body">
          <div className="status">
            <label>Temperatura</label>
            <span>{data.temperature}°C</span>
          </div>

          <div className="status">
            <label>Umidade</label>
            <span>{data.humidity}%</span>
          </div>

          <div className="status-icon">
            {renderStatusIcon(temperatureClass)}
          </div>

          <div className="update-date">
            <span><Moment format="DD/MM/YYYY H:mm:ss">{data.last_update_date}</Moment></span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default DeviceInfo